// src/components/helpers/FormRow.js
import React, { memo } from "react";
import Grid from "@mui/material/Grid";

function FormRow({ children, spacing = 2 }) {
  return (
    <Grid container spacing={spacing} className="form-row">
      {children}
    </Grid>
  );
}

export default memo(FormRow);
